<template>
  <div class="help_item">
    <header>
      <img :src="bannerUrl" alt="" width="100%" />
    </header>
    <div class="content">
      <div class="container">
        <div v-html="contentHtml"></div>
        <!-- <p>暑假正悄悄远去，那种刷完牙就吃中饭的日子也一去不复返。有目标的日子才更鲜活，毕竟一切的美妙都是从我想...开始的。新学期你又有什么新愿望，是不是依旧人未动，Flag先行呢？</p>
        <p>为了更好地助力大学生求职成长，让大学萌新更快适应新学期生活，智联校园发起“你好，新同学”活动，写下你的新学期开学愿望，参与就有机会获得梦想基金！快来加入吧～</p> -->
        <div class="join_btn" @click="handleJoinActivity" v-if="activity">参与活动</div>
        <div class="join_btn" style="background: #DDE0E9; color: #666;" v-else>没有该活动</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  senderOpen,
  getTaskSenderInfo,
  getTaskInfoById
} from "@/api";
export default {
  data () {
    return {
      bannerUrl: require('../../assets/help-activity/kv@2x.png'),
      hasJoined: false,
      currentTaskSenderId: '',
      contentHtml: '',
      activity: true,
    }
  },
  async created () {
    await this.getTaskInfoById();
    await this.senderOpen();
  },
  methods: {
    async getTaskSenderInfo () {
      const postData = {
        taskSenderId: this.$route.query.taskSenderId,
      };
      const res = await getTaskSenderInfo(postData);
      if (res.data && res.data.errorCode == 200) {
        const data = res.data.data;
        if (data.currentTaskSenderId) {
          this.hasJoined = true;
          this.currentTaskSenderId = data.currentTaskSenderId;
        }
      } else {
        this.$notify({
          type: "warning",
          message: res.data.apiErrorMessage,
          duration: 3 * 1000,
        });
      };
    },
    handleJoinActivity () {
      let routerName;
      if (this.hasJoined) {
        routerName = 'HelpActivity'
      } else {
        routerName = 'HelpActivityApply'
      }
      this.$router.push({
        name: routerName,
        query: {
          taskSenderId: this.currentTaskSenderId,
          activityId: this.$route.query.activityId,
          shareId: this.$route.query.shareId,
          taskId: this.$route.query.taskId,
        }
      })
    },
    async senderOpen () {
      const postData = {
        activityId: this.$route.query.activityId,
        taskId: this.$route.query.taskId
      };
      const res = await senderOpen(postData);
      if (res.data && res.data.errorCode == 200) {
        const data = res.data.data;
        if (data.id) {
          this.hasJoined = true;
          this.currentTaskSenderId = data.id;
        }
      } else {
        this.$notify({
          type: "warning",
          message: res.data.apiErrorMessage,
          duration: 3 * 1000,
        });
      }
    },
    async getTaskInfoById () {
      const res = await getTaskInfoById({}, this.$route.query.taskId);
      if (res.data && res.data.errorCode == 200) {
        const data = res.data.data;
        this.bannerUrl = data.bannerUrl;
        this.contentHtml = data.taskDetail;
      } else {
        this.activity = false;
        this.$notify({
          type: "warning",
          message: res.data.apiErrorMessage,
          duration: 3 * 1000,
        });
      }
    },
  }
};
</script>
<style lang="less" scope>
.help_item {
  height: 100%;
  display: flex;
  flex-direction: column;
  header {
    position: relative;
    height: 100vw * 211 / 375;
    overflow: hidden;
    img {
      display: block;
    }
  }
  .content {
    flex: 1;
    background:  url('../../assets/help-activity/bg_image@2x.png') 0 0 no-repeat;
    background-size: 100%;
    padding: 0 10px 10px;
    .container {
      height: 100%;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 0 0 8px 8px;
      padding: 18px 18px 50px;
      box-sizing: border-box;
      position: relative;
      p {
        color: #274A9B;
        line-height: 28px;
        font-size: 15px;
        padding-bottom: 20px;
      }
      .join_btn {
        position: absolute;
        bottom: 25px;
        left: 18px;
        width: calc(100% - 36px);
        height: 38px;
        background: linear-gradient(133deg, #65C7FD 0%, #6662FF 100%);
        border-radius: 19px;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 1.5px;
        line-height: 38px;
        text-align: center;
      }
    }
  }
}
</style>
